import { useQueryState } from "nuqs";

export const useRedirectTo = () => {
  const [redirectTo, setRedirectTo] = useQueryState(
    "redirectTo",
  );

  return {
    redirectTo,
    setRedirectTo,
  };
};
